import React, { useState } from 'react';
import classnames from 'classnames';

import style from './Button.module.scss';
import '@components/mixins/commonStyles.scss';

import { Icon, IconType } from '@components/Icon';

export interface ButtonParams extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    theme?: ButtonTheme;
    modifiers?: ButtonModifiers[];
    label?: string;
    dataTest?: string;
    children?: React.ReactNode;
    additionaClassNames?: string[];
    withAddIcon?: boolean;
}

export enum ButtonTheme {
    // @ts-ignore
    Primary = style.primary,
    // @ts-ignore
    Light = style.light,
    // @ts-ignore
    Link = style.link,
    // @ts-ignore
    Main = style.main,
    // @ts-ignore
    Secondary = style.secondary,
    // @ts-ignore
    White = style.white,
    // @ts-ignore
    Danger = style.danger,
    // @ts-ignore
    Gradient = style.gradient,
    // @ts-ignore
    SecondaryLightHover = style.secondaryLightHover,
    // @ts-ignore
    Transparent = style.transparent,
    // @ts-ignore
    BlackText = style.blackText,
    // @ts-ignore
    Green = style.green,
}

export enum ButtonModifiers {
    // @ts-ignore
    Small = style.small,
    // @ts-ignore
    Big = style.big,
    // @ts-ignore
    WithBorder = style.withBorder,
    // @ts-ignore
    InheritWidth = style.inheritWidth,
    // @ts-ignore
    WithoutLeftAndRightPaddings = style.withoutLeftAndRightPaddings,
    // @ts-ignore
    WithoutPaddings = style.withoutPaddings,
    // @ts-ignore
    CustomHeight = style.customHeight,
    // @ts-ignore
    WithoutBackground = style.withoutBackground,
    // @ts-ignore
    InheritContentPosition = style.inheritContentPosition,
    // @ts-ignore
    MobilePaddings = style.mobilePaddings,
}

export function Button({
    theme = ButtonTheme.Primary,
    modifiers = [],
    children,
    dataTest,
    label,
    additionaClassNames = [],
    withAddIcon,
    disabled,
    onClick,
    ...props
}: ButtonParams) {
    const [isOnClick, setIsOnClick] = useState(false);

    async function handleClick(e: React.MouseEvent<HTMLButtonElement>): Promise<void> {
        if (!!onClick && !isOnClick) {
            setIsOnClick(true);
            try {
                await onClick(e);
            } finally {
                setIsOnClick(false);
            }
        }
    }

    return (
        <button
            data-test={dataTest}
            data-testid={dataTest}
            className={classnames([style.root, theme, 'font_components', ...modifiers, ...additionaClassNames])}
            disabled={isOnClick || disabled}
            onClick={handleClick}
            {...props}
        >
            {withAddIcon && <Icon type={IconType.PLUS} />}
            {children || label}
        </button>
    );
}
